import React, { useState } from 'react';
import {
  Radio, Space, Divider, Col, Row, DatePicker, InputNumber, Form,
} from 'antd';
import getFormItemRules from '../shared/form-helper';
import ASAP from '../assets/images/asap.svg';

const ScheduleCampaign = () => {
  const [radioValue, setRadiovalue] = useState('asap');
  const [showDateTime, setShowDateTime] = useState(false);
  const radioOnChange = (event) => {
    setRadiovalue(event.target.value);
    if (event.target.value === 'periodic' || event.target.value === 'daily') {
      setShowDateTime(true);
    } else {
      setShowDateTime(false);
    }
  };
  return (
    <>
      <div style={{ height: '300px' }}>
        <Row>
          <Col flex={0.5}>
            <p>Send Campaign</p>
            <Form.Item
              name="schedule_campaign"
              rules={[
                ...getFormItemRules({
                  required: true,
                }),
              ]}
            >
              <Radio.Group onChange={radioOnChange}>
                <Space direction="vertical">
                  <label>One Time</label>
                  <Radio value="asap">As soon as possible</Radio>
                  <Radio disabled value="periodic">At specific date and time</Radio>
                  <label>Periodic</label>
                  <Radio disabled value="daily">Daily</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Divider
            type="vertical"
            style={{ height: 'auto', width: '3%' }}
          />
          <Col flex={3}>
            <div>
              <h3>At specific date and time</h3>
              <Divider
                type="horizontal"
                style={{ height: 'auto', width: '3%' }}
              />
              {showDateTime ? (
                <>
                  <div className="grid-auto-2">
                    <Form.Item label="Start Date" name="start_date_time">
                      <DatePicker showTime />
                    </Form.Item>
                  </div>
                  {radioValue === 'daily' && (
                  <Form.Item label="Repeat every" name="every_days">
                    <InputNumber />
                    {' '}
                    days
                  </Form.Item>
                  )}
                </>
              ) : (
                <div>
                  <img src={ASAP} alt="" />
                  <p>The campaign will go out as soon as possible</p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ScheduleCampaign;
